// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {Fragment, useContext, useEffect, useState} from 'react';
import cn from 'classnames';
import styles from './blog/blog.module.less';
import {Link, useHistory} from 'react-router-dom';
import {Settings_context} from '../../settings_ctx';
import {Button} from '../../lib/button';
import {statuses} from '../../data_ctx';
import etask from 'zetask';
import {Paging} from '../../ui/blog/paging';
// @ts-ignore
import {use_data_provider} from '../../lib/use_data_provider';
// @ts-ignore
import {fetch} from '/util/fetch.js';
import {get_article_date, i_arts, get_date_obj} from '../../ui/blog/i_blog';
import {use_pathname} from '../../lib/use_pathname';
import {perr_www_visit} from 'hola_pub_util';

const get_data_id = params=>`/blog/page/${params.page}/category/`+
    `${params.category}`;
const Print_categories = ({theme, item})=>{
    return <Fragment>
      <p className={cn(theme.xs, theme.light)}>
        {item.categories.map(one_cat=>{
            return <span key={one_cat.id}>
              {one_cat.name}
            </span>;
        })} {'\u00B7'} {item.time_to_read} read</p>
      <div className={styles.author}>
        <div className={styles.author_pic}
          style={{
            backgroundImage: `url(${item.author.img})`,
          }}/><p className={cn(theme.xs, theme.light)}>
            {item.author.name}{' \u00B7 '}
            <span className={styles.art_date}>{get_article_date(item)}</span>
          </p>
      </div>
    </Fragment>;
};

export const Root = props=>{
    const {theme} = useContext(Settings_context);
    const root_url = '/blog';
    const history = useHistory();
    const {data} = use_data_provider(get_data_id);
    const {params} = use_pathname();
    const [data_state, set_data_state] = useState(data.result as i_arts);
    useEffect(()=>{
        if (data.status==statuses.done)
            set_data_state(data.result as i_arts);
    }, [data]);
    useEffect(()=>{
        perr_www_visit({id: 'www_blog_visit'});
    }, []);
    return <div className={cn(theme.root, styles.blog_page)}>
      <div className={cn(theme.container, styles.blog_container)}>
        <h1 className={cn(theme.H2, styles.article_title)}>{props.title}</h1>
        {data_state ? <Fragment>
          <div className={styles.categories}>
            {params.category && <Button to={root_url} cls={styles.cat_btn}
              caption={<div className={styles.back_btn}>Back</div>}
              color={'transparent'} size="xs"/>}
            {data_state.data.categories.map(cat=><Button key={cat.id}
              to={`${root_url}/category/${cat.slug}`}
              caption={cat.name} cls={styles.cat_btn}
              color={cat.slug==params.category ? 'active' : 'inactive'}
              size={'xs'}
            />)}
          </div>
          <div className={styles.articles}>
            {data_state.data.posts.map((item, i)=>{
                const art_href = `/blog/article/slug/${item.slug}`;
                const is_popular_block = data_state.data.popular &&
                    data_state.data.popular.length > 0 && i==0;
                return <Fragment key={i}>
                  <div className={cn(styles.article,
                    is_popular_block && styles.big)}
                    onClick={()=>{
                      history.push(art_href);
                  }}>
                    <div className={styles.article_body}>
                      {is_popular_block ?
                        <h5 className={cn(styles.art_title,
                          theme.logo_grey)}>
                          <b dangerouslySetInnerHTML={{__html: item.title}}/>
                        </h5> :
                        <p className={cn(styles.art_title, theme.p2,
                          theme.logo_grey)}>
                          <b dangerouslySetInnerHTML={{__html: item.title}}/>
                        </p>}
                        <Print_categories item={item} theme={theme}/>
                    </div>
                    <Link to={art_href} data-bg={item.img} key={item.slug}
                      className={cn('lazyload', styles.img_link)}></Link>
                  </div>
                  {is_popular_block ? <Fragment>
                    <p className={cn(theme.p2, theme.logo_grey,
                      styles.popular_title)}><b>Popular articles</b></p>
                    <div className={styles.popular}>
                      {data_state.data.popular.map((art, j)=>{
                          const art_p_href = `/blog/article/slug/${art.slug}`;
                          return <div key={j} className={styles.popular_art}
                            onClick={()=>{
                              history.push(art_p_href);
                            }}>
                            <Link to={art_p_href} data-bg={art.img}
                              key={art.id}
                              className={cn('lazyload', styles.popular_img)}/>
                            <div className={styles.popular_body}>
                              <p className={cn(theme.p2, theme.logo_grey,
                                styles.art_title)}>
                                <b dangerouslySetInnerHTML={{
                                  __html: art.title}}></b></p>
                              <Print_categories item={art} theme={theme}/>
                            </div>
                          </div>;
                      })}
                    </div>
                    <p className={cn(theme.p2, styles.recent_title,
                      theme.logo_grey)}><b>Recent articles</b></p>
                  </Fragment> : null}</Fragment>;
            })}
          </div>
          <Paging count={data_state.data.total_pages} param={'page'}/>
        </Fragment> : <div>Loading...</div>}
      </div>
    </div>;
};
Root.meta = {
    ssr_force: true,
    meta: ({data_from_provider})=>{
        const category = data_from_provider && data_from_provider[0]?.category;
        switch (category)
        {
        case 'blog-blog':
            return {
                title: 'Hola | Explore Our Insights: The Latest Hola News '
                    +'and Trends',
                description: 'Join us in revolutionizing content access '
                    +'worldwide! Look no further than our blog for the latest '
                    +'news, expert insights, helpful how-to guides, and so '
                    +'much more!',
                canonical_url: 'https://hola.org/blog/categoy/blog-blog',
            };
        case 'general':
            return {
                title: 'Hola | Explore Our Insights: The Latest Hola News '
                    +'and Trends',
                description: 'Join us in revolutionizing content access '
                    +'worldwide! Look no further than our blog for the latest '
                    +'news, expert insights, helpful how-to guides, and so '
                    +'much more!',
                canonical_url: 'https://hola.org/blog/categoy/general',
            };
        case 'how_to':
            return {
                title: 'Hola | Learn What You Need To Know With Our How To '
                    +'Guides',
                description: 'Confused about our service? Our "How To" '
                    +'category offers a comprehensive collection of guides '
                    +'to help you learn all you need to know about using '
                    +'Hola.',
                canonical_url: 'https://hola.org/blog/category/how_to',
            };
        case 'in-depth':
            return {
                title: 'Hola Blog | Our In-Depth and Insightful Articles',
                description: 'Our "In-Depth" category provides insightful '
                    +'articles on our service, app, and using Hola. Dive '
                    +'deep & explore our collection of thought-provoking '
                    +'articles today.',
                canonical_url: 'https://hola.org/blog/category/in-depth',
            };
        case 'interviews':
            return {
                title: 'Hola Blog | Exclusive Interviews with Our Thought '
                    +'Leaders',
                description: 'Check out exclusive conversations with our '
                    +'experts to gain insights into the minds of our team & '
                    +'learn valuable lessons on accessing content & staying '
                    +'secure online.',
                canonical_url: 'https://hola.org/blog/category/interviews',
            };
        case 'news':
            return {
                title: 'Hola | Read Our Latest News and Updates To Stay In '
                    +'The Loop',
                description: 'Stay up-to-date with our latest news now. From '
                    +'Hola news to current affairs and trending topics, get '
                    +'a comprehensive overview of what\'s happening at Hola.',
                canonical_url: 'https://hola.org/blog/category/news',
            };
        case 'product-news':
            return {
                title: 'Hola Blog | Product News and Updates - Be the First '
                    +'to Know',
                description: 'Be the first to know about new features, '
                    +'improvements, and releases, and stay informed about '
                    +'how our service can benefit you! Check out our product '
                    +'news category.',
                canonical_url: 'https://hola.org/blog/category/product-news',
            };
        default:
            return {
                title: 'Hola | The Latest News On Accessing Content Online',
                description: 'Gain valuable insights into how to unblock '
                    +'websites, protect your privacy, & surf the web with '
                    +'freedom by checking out our blog! Join the Hola '
                    +'community today!',
                canonical_url: 'https://hola.org/blog/category'
                + category ? `/${category}` : '/blog-blog',
            };
        }
    },
    is_dark_available: true,
    set_data_cache: (data_cache, params, data)=>{
        data_cache[`/blog/page/${params.page}/category/${params.category}`]
            = data;
    },
    get_data_id,
    data_provider: (data_cache, params)=>etask(function*(){
        const cache_key = `/blog/page/${params.page}/category/`+
            `${params.category}`;
        const cached = data_cache[cache_key];
        if (cached)
            return cached;
        let popular = {posts: []};
        let not_in = [];
        if ((!params.page || params.page=='1') && !params.category)
        {
            popular = yield fetch(`https://hola.org/cms_api/blog/posts_popular`
                +`?posts_per_page=3&paged=0`);
            if (typeof popular!='object')
                popular = {posts: []};
            popular.posts = popular.posts||[];
            let count = Math.min(popular.posts.length, 3);
            for (let i=0;i<count;i++)
                not_in.push(popular.posts[i].id);
        }
        const end = `https://hola.org/cms_api/blog/posts`;
        not_in = [];
        let data = yield fetch(`${end}?posts_per_page=10`+
            `&paged=${params.page||0}${params.category ?
            `&category=${params.category}` : ''}`+
            `${not_in.length>0 ? `&post__not_in=${not_in.join(',')}` : ''}`);
        if (typeof data!='object')
            data = {};
        data.popular = popular.posts;
        data.posts = data.posts||[];
        data.categories = data.categories||[];
        let newest = data.posts[0];
        let index = -1;
        for (let i=0;i<popular.posts.length;i++)
        {
            const datetime = get_date_obj(popular.posts[i]);
            if (get_date_obj(newest)<datetime)
            {
                newest = popular.posts[i];
                index = i;
            }
        }
        if (index>-1)
        {
            // data.posts.unshift(newest);
            // popular.posts.splice(index, 1);
        }
        const result = {
            data,
            error: '',
            cache_key,
            category: params.category,
        };
        data_cache[cache_key] = result;
        return result;
    }),
};
